import MixesContent from "../components/MixesContent"


const Mixes = () => {
  return <MixesContent></MixesContent>
}

export default Mixes
